import React from 'react';
import './Activities.css';

function Activities() {
    const activities = [
        {
            icon: '/images/icons/community-icon.webp',
            title: 'Empowering Communities for Smarter Waste Management',
            description: `Leading the way in responsible waste disposal and municipal collaboration, 
            CleanSweep simplifies the process of waste segregation and compliance.`,
            image: '/images/community-empowerment.webp',
        },
        {
            icon: '/images/icons/delivery-icon.webp',
            title: 'Hassle-Free Delivery of Waste Solutions',
            description: `Experience seamless waste management! CleanSweep delivers your chosen containers, bins, or skips directly to your premises—completely free of charge.`,
            image: '/images/waste-delivery.webp',
        },
        {
            icon: '/images/icons/collection-icon.webp',
            title: 'Swift and Flexible Waste Collection',
            description: `Your convenience is our priority! CleanSweep ensures waste collection within 24 hours of confirmation. Flexible services adapted to your needs.`,
            image: '/images/waste-collection.webp',
        },
        {
            icon: '/images/icons/approval-icon.webp',
            title: 'Municipality Approved Waste Disposal',
            description: `At CleanSweep, we prioritize compliance. Every load collected is routed to Dubai Municipality-authorized landfills, ensuring legal and sustainable practices.`,
            image: '/images/municipality-approval.webp',
        },
        {
            icon: '/images/icons/services-icon.webp',
            title: 'Comprehensive Waste Collection Services',
            description: `From construction and demolition debris to wet and dry waste, CleanSweep handles it all with efficient and eco-friendly solutions for every sector.`,
            image: '/images/waste-services.webp',
        },
        {
            icon: '/images/icons/transport-icon.webp',
            title: 'Complete Waste Transportation Solutions',
            description: `Equipped with compactor vehicles for residential waste and robust skip services for construction, we ensure reliable disposal for any project.`,
            image: '/images/transportation.webp',
        },
    ];

    return (
        <section className="activities" id="activities">
            <div className="activities-header">
                <span className="subtitle">Our Services</span>
                <h2 className="activities-heading">Waste Collection & Disposal Services in Dubai</h2>
                <div className="heading-underline"></div>
            </div>

            <div className="activities-grid">
                {activities.map((activity, index) => (
                    <div key={index} className="activity-card">
                        <div className="card-top">
                            <div className="activity-icon-box">
                                <img src={activity.icon} alt="Icon" />
                            </div>
                            <h3>{activity.title}</h3>
                            <p>{activity.description}</p>
                        </div>
                        <div className="activity-image-box">
                            <img src={activity.image} alt={activity.title} loading="lazy" />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Activities;